// MACHINERY V2 (Stroje) — mobile kit glyphs (M2.16a).
//
// WHAT THIS OWNS: the four SVGs the mobile chrome draws and the desktop
// chrome has no use for. Values transcribed from the design package's
// mobile/machinery-mobile.jsx (MbFilterGlyph :43-45, MbChrome's hamburger
// :25) and mobile/machinery-profile-phone.jsx.
//
// WHY ITS OWN FILE: three consumers already (FilterBarB, MobilePhoneHeader,
// ActiveFilterChips) and two more coming at 16c/16d, so the alternative is the
// same path data pasted five times. The desktop glyphs stay where they are —
// FleetToolbar's SearchGlyph is 13px and tuned for a 32px control; these are
// sized for 44px targets, so they are different drawings, not a duplicate.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

/** The three-bar filter mark on the Filtre button (MbFilterGlyph). */
export const MbFilterGlyph: React.FC = () => (
  <svg
    viewBox="0 0 14 12"
    width="13"
    height="11"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    aria-hidden
  >
    <path d="M1 2h12M3.5 6h7M5.5 10h3" />
  </svg>
);

/** Search mark, drawn one step larger than FleetToolbar's because it sits in a
 *  44px field rather than a 32px one. */
export const MbSearchGlyph: React.FC = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden>
    <circle cx="6.5" cy="6.5" r="4.6" stroke="currentColor" strokeWidth="1.3" />
    <line
      x1="10"
      y1="10"
      x2="13.5"
      y2="13.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

/** Phone-header hamburger (MbChrome :25 — 17x13, three 1.6 strokes). */
export const MbMenuGlyph: React.FC = () => (
  <svg
    viewBox="0 0 16 12"
    width="17"
    height="13"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    aria-hidden
  >
    <path d="M1 1.5 L15 1.5 M1 6 L15 6 M1 10.5 L15 10.5" />
  </svg>
);

/** Dismiss mark inside an active-filter chip. Decorative: the whole chip is
 *  the button (see ActiveFilterChips.tsx), so this never carries the label. */
export const MbDismissGlyph: React.FC = () => (
  <svg
    viewBox="0 0 10 10"
    width="9"
    height="9"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    aria-hidden
  >
    <path d="M2 2 L8 8 M8 2 L2 8" />
  </svg>
);

/** Vertical three-dot kebab, sized for a 44px touch target. */
export const MbKebabGlyph: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden>
    <circle cx="8" cy="3" r="1.4" />
    <circle cx="8" cy="8" r="1.4" />
    <circle cx="8" cy="13" r="1.4" />
  </svg>
);
